import { render, staticRenderFns } from "./classesList.vue?vue&type=template&id=1f2b47de&scoped=true&"
import script from "./classesList.vue?vue&type=script&lang=js&"
export * from "./classesList.vue?vue&type=script&lang=js&"
import style0 from "./classesList.vue?vue&type=style&index=0&id=1f2b47de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b47de",
  null
  
)

component.options.__file = "classesList.vue"
export default component.exports